export class Superambito {
  ID: number;
  DEPENDE_AYTO: boolean;
  NOMBRE: string;
}
